export default "__VITE_PUBLIC_ASSET__562ba021__"